import React, { Fragment, lazy, Suspense, useContext, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { Layout, Loader, LocaleContext, ScrollToTop } from 'shared';

import { resizeHeader } from '../utils/resizeHeader/resizeHeader';

import { ContactPageContainer } from './contactPage/ContactPageContainer';
import { CookiesInfoContainer } from './core/cookiesInfo/CookiesInfoContainer';
import { FooterContainer } from './core/footer/FooterContainer';
import { HeaderContainer } from './core/header/HeaderContainer';
import { FAQContainer } from './faq/FAQContainer';
import { HomePageContainer } from './homePage/HomePageContainer';
import { HowToContainer } from './howTo/HowToContainer';
import { ReportPageContainer } from './reportPage/ReportPageContainer';
import { StaticPagesContainer } from './staticPages/StaticPagesContainer';

const Documentation = lazy(() => import('./documentation/DocumentationContainer'));

const DocumentationRoute = () => {
  const { slug } = useParams();
  const location = useLocation();

  return (
    <Suspense fallback={<Loader />}>
      <Documentation slug={slug || ''} location={location} />
    </Suspense>
  );
};

export const App = () => {
  const context = useContext(LocaleContext);

  /* This hook is used for pushing content down based on the height of the header */
  useEffect(() => {
    window.onresize = resizeHeader;
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <Fragment>
          <Helmet>
            <title>{context.formatMessage({ id: 'GENERAL.TITLE' })}</title>
          </Helmet>

          <Layout header={<HeaderContainer />} footer={<FooterContainer />}>
            <Routes>
              <Route path="/documentation/:slug/*" element={<DocumentationRoute />} />
              <Route path="/how-to/*" element={<HowToContainer />} />
              <Route path="/faq/*" element={<FAQContainer />} />
              <Route path="/pages/*" element={<StaticPagesContainer />} />
              <Route path="/contact/*" element={<ContactPageContainer />} />
              <Route path="/reports/*" element={<ReportPageContainer />} />
              <Route path="/" element={<HomePageContainer />} />
              <Route path="*" element={<Navigate to="/" replace={true} />} />
            </Routes>
          </Layout>

          <ScrollToTop />
          <CookiesInfoContainer />
        </Fragment>
      </Router>
    </HelmetProvider>
  );
};
